import { getGridStringOperators } from "@mui/x-data-grid";

const TURKISH_STRING_OPS = new Set(["contains", "startsWith", "endsWith", "equals", "isAnyOf"]);

// İ→i (tr) and I→ı (tr) then ı→i so EN "ibrahim" still matches "Ibrahim".
function foldSearchString(value) {
  return value.toLocaleLowerCase("tr").replaceAll("ı", "i");
}

function wrapTurkishOperator(operator) {
  if (!TURKISH_STRING_OPS.has(operator.value)) return operator;

  return {
    ...operator,
    getApplyFilterFn: (filterItem) => {
      if (operator.value === "isAnyOf") {
        if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
        const needles = filterItem.value.map((v) => foldSearchString(String(v).trim()));
        return ({ value }) =>
          value !== null && value !== undefined && needles.includes(foldSearchString(value.toString()));
      }

      if (!filterItem.value) return null;
      const needle = foldSearchString(String(filterItem.value).trim());
      return ({ value }) => {
        if (value === null || value === undefined) return false;
        const haystack = foldSearchString(value.toString());
        if (operator.value === "contains") return haystack.includes(needle);
        if (operator.value === "startsWith") return haystack.startsWith(needle);
        if (operator.value === "endsWith") return haystack.endsWith(needle);
        return haystack === needle;
      };
    },
  };
}

const turkishStringOperators = getGridStringOperators().map(wrapTurkishOperator);

export function withTurkishStringFilter(column) {
  if (!column || column.filterable === false) return column;
  if (column.type && column.type !== "string") return column;
  if (column.filterOperators) {
    return { ...column, filterOperators: column.filterOperators.map(wrapTurkishOperator) };
  }
  return { ...column, filterOperators: turkishStringOperators };
}

export function withTurkishStringFilters(columns) {
  return Array.isArray(columns) ? columns.map(withTurkishStringFilter) : columns;
}

export function getColumnValue(field, headerName, options, id, width) {
  return {
    field,
    headerName,
    width,
    valueGetter: (params) => {
      try {
        return options.find((item) => item?.value?.toString() === params?.row[id]?.toString())?.label?.toString();
      } catch {
        return "-";
      }
    },
  };
}
